import React from "react";
import {
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  Select,
  Input,
  InputGroup,
  InputRightAddon,
  Radio,
  RadioGroup,
} from "@chakra-ui/react";
import "./lplock.css";

const LpLock = ({ formValues, setFormValues }) => {
  return (
    <div className="lplock-main">
      <div className="linethrough">LP AND LOCK CONFIGS</div>
      <div className="lp-holder">
        <div className="row-first">
          <div className="slider-and-label">
            <label htmlFor="">Liquidity Proportion <span className="astrick">*</span></label>
            <div className="slider-and-value">
              <Slider
                aria-label="slider-ex-1"
                value={formValues.liquidityProportion}
                min={95}
                max={100}
                onChange={(value) =>
                  setFormValues({ ...formValues, liquidityProportion: value })
                }
              >
                <SliderTrack>
                  <SliderFilledTrack />
                </SliderTrack>
                <SliderThumb />
              </Slider>
              <div className="value">{formValues.liquidityProportion}%</div>
            </div>
          </div>
          <div className="input-part">
            <label htmlFor="">Native Liquid <span className="astrick">*</span></label>
            <InputGroup size="sm">
              <Input
                placeholder="min 1"
                onChange={(e) =>
                  setFormValues({ ...formValues, nativeLiquid: e.target.value })
                }
              />
              <InputRightAddon children="BNB" />
            </InputGroup>
          </div>
        </div>
        <div className="row-second">
          <div className="radio-div">
            <label htmlFor="">Lp Lock Services</label>
            <div>
              <RadioGroup
                className="radio-holder"
                value="1"
                onChange={(value) =>
                  setFormValues({
                    ...formValues,
                    lpLockService: value,
                  })
                }
              >
                <Radio value="1" isChecked={true}>Pinksale</Radio>
              </RadioGroup>
            </div>
          </div>
          <div className="sel-div">
            <label htmlFor="tokenname">
              How many days will it be locked? <span className="astrick">*</span>
            </label>
            <Select
              size="sm"
              onChange={(e) =>
                setFormValues({ ...formValues, lockedFor: e.target.value })
              }
            >
              <option value="1 Month">1 Month </option>
              <option value="2 Months">2 Months </option>
              <option value="3 Months">3 Months </option>
              <option value="6 Months">6 Months </option>
              <option value="9 Months">9 Months </option>
              <option value="1 Year">1 Year </option>
              <option value="2 Years">2 Years </option>
            </Select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LpLock;
